import ICompAddress from '../CompAddress';
import ISourceData from './ISourceData';

export default interface IFeedData {
    initials?: string | null;
    records?: number | null;
    yourCount?: number | null;
    peerCount?: number | null;
    reportUseCount?: number | null;
    isPeerComp?: boolean | null;
    address?: ICompAddress;
    sourceData?: ISourceData;
}

export function newFeedData(): IFeedData {
    const feedData: IFeedData = {};
    return feedData;
}
